(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[27335],{

/***/ 42267:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apps/[id]",
      function () {
        return __webpack_require__(30028);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SEO = function(param) {
    var url = param.url, title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: "aiso, 인공지능, 인공지능 서비스, AI, machine learning"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url ? url : "https://aiso.ai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title ? title : "인공지능 서비스 마켓 아이소"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: desc ? desc : "AISO는 웹 기반의 다양한 AI 서비스를 쉽게 제작 판매하고 이용할 수 있는 인공지능플랫폼입니다."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "https://aiso.ai/images/header/aiso_logo.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 81268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5566);
/* harmony import */ var components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4534);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32692);





var MaterialModal = function(param) {
    var children = param.children, open = param.open, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        "aria-labelledby": "spring-modal-title",
        "aria-describedby": "spring-modal-description",
        className: "popup-wrap",
        open: open,
        onClose: closeModal,
        closeAfterTransition: true,
        disableScrollLock: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        outline: 0,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: open,
            className: "center2",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaterialModal);


/***/ }),

/***/ 4534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39920);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







/* Material-UI 모달 Fade */ var ModalFade = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Fade(props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "in",
        "children",
        "onEnter",
        "onExited"
    ]);
    var style = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
        config: {
            duration: 10
        },
        from: {
            opacity: 0
        },
        to: {
            opacity: open ? 1 : 0
        },
        onStart: function() {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function() {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        style: style
    }, other), {
        children: children
    }));
});
ModalFade.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
    in: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    onEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onExited: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalFade);


/***/ }),

/***/ 30028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79794);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _DataAnalysisApp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69281);
/* harmony import */ var pages_user_market_appDetailMenu_appTitle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2839);
/* harmony import */ var pages_user_market_appDetailMenu_appPreview__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45875);
/* harmony import */ var pages_user_market_appDetailMenu_appContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40366);
/* harmony import */ var pages_user_market_appDetailMenu_appRun_Basic__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53489);
/* harmony import */ var pages_user_market_appDetailMenu_appRun_Custom__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4092);
/* harmony import */ var pages_user_market_appDetailMenu_appLicense__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31266);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15503);
/* harmony import */ var components_SEO__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68590);

















var AppPages = function(param) {
    var headUrl = param.headUrl, headTitle = param.headTitle, headDesc = param.headDesc;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), data = ref[0], setData = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var id, publicDocRef, privateDocRef, publicValue, privateValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = router.query.id;
                    if (!id) return [
                        3,
                        7
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    publicDocRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_3__/* .projectFirestore.collection */ .H.collection("market").doc("public").collection("app").doc(id);
                    privateDocRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_3__/* .projectFirestore.collection */ .H.collection("market").doc("private").collection("app").doc(id);
                    return [
                        4,
                        publicDocRef.get()
                    ];
                case 2:
                    publicValue = _state.sent();
                    if (!publicValue.exists) return [
                        3,
                        3
                    ];
                    setData(publicValue.data());
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        privateDocRef.get()
                    ];
                case 4:
                    privateValue = _state.sent();
                    if (privateValue.exists) {
                        setData(privateValue.data());
                    }
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    }), [
        router
    ]);
    if (data) {
        if (data.category === "dataAnalysis") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DataAnalysisApp__WEBPACK_IMPORTED_MODULE_5__["default"], {
                    email: data.email,
                    appId: data.appId,
                    appName: data.appName,
                    inputFile: data.inputFile,
                    target: data.target,
                    csvInfo: data.csvInfo,
                    outputJson: data.outputJson,
                    outputHtml: data.outputHtml,
                    outputMatrix: data.outputMatrix ? data.outputMatrix : ""
                })
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SEO__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        url: headUrl,
                        title: headTitle,
                        desc: headDesc
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "page-content w-full pt-12 pb-36",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "aiso-card shadow-md",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_user_market_appDetailMenu_appTitle__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                        appName: data.appName,
                                        price: data.price
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_user_market_appDetailMenu_appPreview__WEBPACK_IMPORTED_MODULE_7__["default"], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, data)),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_user_market_appDetailMenu_appContent__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                        content: data.content
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_user_market_appDetailMenu_appLicense__WEBPACK_IMPORTED_MODULE_11__["default"], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, data)),
                                    data.type === "custom" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_user_market_appDetailMenu_appRun_Custom__WEBPACK_IMPORTED_MODULE_10__["default"], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, data)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_user_market_appDetailMenu_appRun_Basic__WEBPACK_IMPORTED_MODULE_9__["default"], (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, data))
                                ]
                            })
                        })
                    })
                ]
            });
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full flex justify-center items-center",
        style: {
            width: "100%",
            minHeight: "100vh"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-4",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "loader-demo-box2 mt-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "dot-opacity-loader",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: "잠시만 기다려주세요..."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: {
                            pathname: "/user/market"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "",
                            className: "btn btn-info text-xs font-bold px-3 py-2 mr-3 mt-4",
                            children: "AISO 로 이동하기"
                        })
                    })
                ]
            })
        ]
    });
};
AppPages.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function(param) {
        var asPath, query, id, headTitle, headDesc, headUrl, publicDocRef, privateDocRef, publicValue, privateValue, error, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    asPath = param.asPath, query = param.query;
                    id = query.id;
                    headTitle = "아이소";
                    headDesc = "인공지능 마켓, 아이소 입니다.";
                    headUrl = "https://aiso.ai".concat(asPath);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    publicDocRef = firebase_app__WEBPACK_IMPORTED_MODULE_12__/* ["default"].firestore */ .Z.firestore().collection("market").doc("public").collection("app").doc(id);
                    privateDocRef = firebase_app__WEBPACK_IMPORTED_MODULE_12__/* ["default"].firestore */ .Z.firestore().collection("market").doc("private").collection("app").doc(id);
                    return [
                        4,
                        publicDocRef.get()
                    ];
                case 2:
                    publicValue = _state.sent();
                    if (!publicValue.exists) return [
                        3,
                        3
                    ];
                    headTitle = publicValue.data().appName;
                    headDesc = publicValue.data().oneLineContent;
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        privateDocRef.get()
                    ];
                case 4:
                    privateValue = _state.sent();
                    if (privateValue.exists) {
                        headTitle = privateValue.data().appName;
                        headDesc = privateValue.data().oneLineContent;
                    }
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    _tmp = {};
                    return [
                        2,
                        (_tmp.headUrl = headUrl, _tmp.headTitle = headTitle, _tmp.headDesc = headDesc, _tmp)
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (AppPages);


/***/ }),

/***/ 40366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9607);
/* harmony import */ var _material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50743);
/* harmony import */ var _material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61201);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64566);








var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "100%",
            boxShadow: "none",
            backgroundColor: " rgba(255, 255, 255, 0.4) !important",
            borderBottom: "3px solid rgba(255, 255, 255, 0.5) !important"
        },
        padding: {
            paddingTop: "7px",
            paddingBottom: "7px"
        },
        heading: {
            fontSize: theme.typography.pxToRem(16),
            fontWeight: "bold",
            color: "#000"
        },
        contentBg: {
            backgroundColor: " rgba(255, 255, 255, 0.6) !important",
            paddingTop: "30px"
        }
    };
});
var AppContent = function(param) {
    var content = param.content;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full px-6 lg:px-32 pt-3",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                    className: classes.padding,
                    "aria-controls": "panel1a-content",
                    id: "panel1a-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: classes.heading,
                        children: "설명 상세보기"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: classes.contentBg,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: content
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AppContent);


/***/ }),

/***/ 31266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9607);
/* harmony import */ var _material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50743);
/* harmony import */ var _material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61201);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64566);








var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            width: "100%",
            boxShadow: "none",
            backgroundColor: " rgba(255, 255, 255, 0.4) !important",
            borderBottom: "3px solid rgba(255, 255, 255, 0.5) !important"
        },
        padding: {
            paddingTop: "7px",
            paddingBottom: "7px"
        },
        heading: {
            fontSize: theme.typography.pxToRem(16),
            fontWeight: "bold",
            color: "#000"
        },
        contentBg: {
            backgroundColor: " rgba(255, 255, 255, 0.6) !important",
            paddingTop: "30px"
        }
    };
});
var AppContent = function(param) {
    var license = param.license;
    var classes = useStyles();
    if (license) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full px-6 lg:px-32 pt-1 pb-5",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: classes.root,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                        className: classes.padding,
                        "aria-controls": "panel1a-content",
                        id: "panel1a-header",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: classes.heading,
                            children: "LICENSE"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_AccordionDetails__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: classes.contentBg,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: license
                            },
                            className: "text-xs break-all"
                        })
                    })
                ]
            })
        });
    } else {
        return "";
    }
};
/* harmony default export */ __webpack_exports__["default"] = (AppContent);


/***/ }),

/***/ 2839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var AppTitle = function(param) {
    var appName = param.appName, price = param.price;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full px-6 lg:px-32 pt-10 pb-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "sm:flex justify-between items-start",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-xl font-bold text-black break-all sm:pr-5",
                    children: appName
                }),
                Number(price) === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center",
                    children: "Free"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-base text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "font-bold text-lg text-black mr-1",
                            children: price
                        }),
                        " Credit"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AppTitle);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [85477,34619,52387,94924,76328,85388,868,22004,39054,32512,88920,19843,13716,94637,16270,99573,82778,45875,4092,53489,69281,49774,92888,40179], function() { return __webpack_exec__(42267); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);